import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useRealmApp } from "../RealmApp";
import { useDatesContext } from "../context/DatesContext";

const useCustomers = () => {
  const app = useRealmApp();
  const { customers, loading } = useAllCustomers(app.currentUser.id);
  return {
    loading,
    customers,
  };
};

export default useCustomers;

function useAllCustomers(ownerId) {
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl("useAllCustomers", 60 * 1000);
  const { data, loading, error } = useQuery(
    gql`
      query getCustomers($ownerId: String!) {
        customers(query: { owner_id: $ownerId }, limit: 0) {
          _id
          address1
          address2
          city
          contactEmail
          contactName
          contactPhone
          country
          dateOfBirth
          email
          idNumber
          language
          lastName
          lastPurchaseDatetime
          name
          notes
          owner_id
          phone
          phone2
          qrData
          ref
          storeId
          tags
          webPage
          zip
          updateDatetime
          creationDatetime
        }
      }
    `,
    {
      variables: { ownerId },
      fetchPolicy,
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const customers = data?.customers ?? [];
  return { customers, loading };
}
